import { render } from "./contactsInfo.vue?vue&type=template&id=66edfcbc&scoped=true"
import script from "./contactsInfo.vue?vue&type=script&lang=js"
export * from "./contactsInfo.vue?vue&type=script&lang=js"

import "./contactsInfo.vue?vue&type=style&index=0&id=66edfcbc&lang=scss&scoped=scoped"

import exportComponent from "E:\\giteeWorkShowma\\hardware-pc\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66edfcbc"]])

export default __exports__